import { render } from "./AssetSettingTabs.vue?vue&type=template&id=f56e7a82&scoped=true"
import script from "./AssetSettingTabs.vue?vue&type=script&lang=js"
export * from "./AssetSettingTabs.vue?vue&type=script&lang=js"

import "./AssetSettingTabs.vue?vue&type=style&index=0&id=f56e7a82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56e7a82"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel});
